// @flow

import type { State } from './reducers';
import type { Nav, Menus } from './types';
import { getHeaderMenuKey, getFooterMenuKey } from '../businessLabelSettings';
import type { BusinessLabelSettings } from '../businessLabelSettings/types';
import type { State as RouterState } from '../router/types';
import type { State as RoutesState } from '../routes/types';
import { DEFAULT_HEADER_MENU, DEFAULT_FOOTER_MENU } from './constants';

type GlobalState = {
  menus: State,
  businessLabelSettings: BusinessLabelSettings,
  router: RouterState,
  routes: RoutesState,
};

const getReducer = (state: GlobalState): State => state.menus;

export const getHeaderMenu = (state: GlobalState): Nav => {
  const menus = getReducer(state);
  const activeHeaderMenu = getHeaderMenuKey(state);

  if (activeHeaderMenu === '') {
    return menus[DEFAULT_HEADER_MENU];
  }
  return menus[activeHeaderMenu];
};

export const getFooterMenu = (state: GlobalState): Nav => {
  const menus = getReducer(state);
  const activeFooterMenu = getFooterMenuKey(state);

  if (activeFooterMenu === '') {
    return menus[DEFAULT_FOOTER_MENU];
  }
  return menus[activeFooterMenu];
};

export const getFooterBottomMenu = (state: GlobalState): Nav => {
  const menus = getReducer(state);
  return menus.footer_bottom_menu;
};

export const getMenus = (state: GlobalState): Menus => {
  const { menus } = state;
  if (!menus) {
    throw new Error('Missing menus store.');
  }
  return menus;
};

// The default export still excists because of backward compatibility
export default (state: GlobalState): Menus => {
  const { menus } = state;
  if (!menus) {
    throw new Error('Missing menus store.');
  }
  return menus;
};
